import { render, staticRenderFns } from "./recognize_fj.vue?vue&type=template&id=334a9679&scoped=true"
import script from "./recognize_fj.vue?vue&type=script&lang=js"
export * from "./recognize_fj.vue?vue&type=script&lang=js"
import style0 from "./recognize_fj.vue?vue&type=style&index=0&id=334a9679&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334a9679",
  null
  
)

export default component.exports